import { render } from "./MultiLabelDropdown.vue?vue&type=template&id=17076de9&scoped=true"
import script from "./MultiLabelDropdown.vue?vue&type=script&lang=ts"
export * from "./MultiLabelDropdown.vue?vue&type=script&lang=ts"

import "./MultiLabelDropdown.vue?vue&type=style&index=0&id=17076de9&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-17076de9"

export default script